export default defineNuxtPlugin((nuxtApp) => {
  if (
    nuxtApp.$config.public.appMode === 'test' ||
    nuxtApp.$config.public.appMode === 'release' ||
    common.getQueryVariable('vconsole')
  ) {
    // 动态创建 script 标签
    const script = document.createElement('script')
    // 预发布base会为/release
    script.src =
      (nuxtApp.$config.public.appMode === 'release'
        ? nuxtApp.$config.public.baseUrl
        : '') + '/cdn/js/vconsole@3.15.1.min.js'
    script.async = true
    script.onload = () => {
      // 初始化 vConsole
      new window.VConsole({ theme: 'dark' })
    }
    document.body.appendChild(script)
  }
})
